import React, { useState } from "react";
import styles from "./JobListEditor.module.css";
import { formatDay } from "./dueDates";

// A milestone's job list inside the project form: tick, rename, remove and add steps.
export default function JobListEditor({ jobs, canEdit, canTick, onAdd, onToggle, onRename, onRemove }) {
  const [draft, setDraft] = useState("");
  const done = jobs.filter((j) => j.done_at).length;

  const submit = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    if (draft.trim()) onAdd(draft.trim());
    setDraft("");
  };

  return (
    <div className={styles.editor}>
      <div className={styles.head}>
        <strong>Job list</strong>
        <span>{done} of {jobs.length} done · ticking the last one completes the milestone</span>
      </div>
      <div className={styles.track}><div style={{ width: `${jobs.length ? (done / jobs.length) * 100 : 0}%` }} /></div>
      <ul>
        {jobs.map((job) => (
          <li key={job.id}>
            <input type="checkbox" checked={Boolean(job.done_at)} disabled={!canTick} onChange={() => onToggle(job)} aria-label={job.title} />
            {canEdit ? (
              <input
                className={`${styles.title} ${job.done_at ? styles.titleDone : ""}`}
                defaultValue={job.title}
                onBlur={(e) => { const v = e.target.value.trim(); if (v && v !== job.title) onRename(job, v); else e.target.value = job.title; }}
                onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
                aria-label="Job title"
              />
            ) : (
              <span className={`${styles.title} ${job.done_at ? styles.titleDone : ""}`}>{job.title}</span>
            )}
            {job.done_at && <span className={styles.meta}>{job.done_by_name ? `${job.done_by_name} · ` : ""}{formatDay(job.done_at)}</span>}
            {canEdit && <button type="button" onClick={() => onRemove(job)} aria-label={`Remove ${job.title}`}>×</button>}
          </li>
        ))}
      </ul>
      {canEdit && (
        <input className={styles.add} placeholder="+ Add a job and press Enter" value={draft}
          onChange={(e) => setDraft(e.target.value)} onKeyDown={submit} />
      )}
    </div>
  );
}
